// src/utils/logger.js

let isConsole = true; // Default to true

// Initialize logger from backend
const initLogger = async () => {
  try {
    // Check session storage first
    const cached = sessionStorage.getItem('logging_enabled');
    
    if (cached !== null) {
      isConsole = cached === 'true';
      if (isConsole) {
        console.log('🔧 Logger Configuration from Session:', { enabled: isConsole });
      }
      return;
    }

    // ✅ Fetch directly without importing from api.js
    const backendUrl = process.env.REACT_APP_BACKEND ;
    const response = await fetch(`${backendUrl}/astro/config/logger-status`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    
    const data = await response.json();
    isConsole = data.loggingEnabled;
    
    // Cache in session storage
    sessionStorage.setItem('logging_enabled', isConsole.toString());
    
    if (isConsole) {
      console.log('🔧 Logger Configuration from Backend:', {
        enabled: isConsole,
        source: 'Backend .env'
      });
    }
  } catch (error) {
    console.warn('⚠️ Could not fetch logger status, defaulting to enabled');
    isConsole = true;
    sessionStorage.setItem('logging_enabled', 'true');
  }
};

// Initialize immediately
initLogger();

const logger = {
  log: (...args) => {
    if (isConsole) console.log(...args);
  },

  info: (...args) => {
    if (isConsole) console.log(...args);
  },

  success: (...args) => {
    if (isConsole) console.log(...args);
  },

  warn: (...args) => {
    if (isConsole) console.warn(...args);
  },

  error: (...args) => {
    // ✅ ALWAYS log errors, even in production
    console.error(...args);
  },

  debug: (...args) => {
    if (isConsole) console.log(...args);
  },

  separator: () => {
    if (isConsole) console.log('═══════════════════════════════════════════════════════════════════════════════');
  },

  table: (data) => {
    if (isConsole) console.table(data);
  },
  
  isEnabled: () => isConsole,
  
  // Refresh logger status from backend
  refresh: async () => {
    sessionStorage.removeItem('logging_enabled');
    await initLogger();
  }
};

export default logger;
export { isConsole };